import { Component, Input, OnDestroy } from '@angular/core';

@Component({
  selector: 'hlu-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent implements OnDestroy {
  private timeout: any;
  isActive = true;

  @Input()
  public delay = 0;
  @Input()
  public width = '40px';
  @Input()
  public height = '40px';

  @Input()
  public set active(value: boolean) {
    if (value && this.isActive) {
      // we are already active
      return;
    }
    if (!value && this.isActive) {
      // we are turning the spinner off
      this.off();
    } else if (value) {
      // we are turning the spinner on
      this.on();
    }
  }

  private on(): void {
    this.isActive = true;
  }

  private off(): void {
    this.timeout = setTimeout(() => {
      this.isActive = false;
      this.cancelTimeout();
    }, this.delay);
  }

  private cancelTimeout(): void {
    clearTimeout(this.timeout);
    this.timeout = undefined;
  }

  ngOnDestroy(): void {
    this.cancelTimeout();
  }
}
